import { MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';

// Dialog constants
export const dialogConfig: MatDialogConfig = {
  data: null,
  position: {
    top: '50px'
  }
};
export const dialogConfigTop = '20%';
export const dialogSize300 = '300px';
export const dialogSize400 = '400px';
export const dialogSize450 = '450px';
export const dialogSize600 = '600px';

// SnackBar constants
export const snackBarConfig: MatSnackBarConfig<any> = {
  duration: 3000,
  verticalPosition: 'top',
  horizontalPosition: 'right'
};

// SnackBar constants
export const snackBarMailConfig: MatSnackBarConfig<any> = {
  duration: 15000,
  verticalPosition: 'top',
  horizontalPosition: 'center',
  panelClass: ['success-snackbar']
};

// registration confirmation
export const successStep = 'success-step';
export const resendStep = 'resend-step';

// RxJs constants
export const debounceTimeMilliseconds = 500;

// login
export const rememberMeLogin = 'remember_me';
export const loginUUID = 'loginUUID';
export const emailNotConfirmed = 'email_not_confirmed';
export const invalidLink = 'invalid_link';

// Notifications
export const socialRegister = 'notifications.social';
export const checkEmail = 'notifications.checkEmail';
export const success = 'notifications.success';
export const deleteUserSuccess = 'notifications.deleteUser';
export const passwordUpdated = 'notifications.passwordUpdated';
export const registerSuccess = 'notifications.registerSuccess';
export const errorType = 'notifications.error';
export const photoLoadFailed = 'notifications.photoLoadFailed';
export const photoTypeNotAllowed = 'notifications.photoTypeNotAllowed';
export const photoTooLarge = 'notifications.photoTooLarge';

// filter
export const tableFilterDefaults = {
  page: 0,
  size: 10,
  sort: 'id,asc'
};

// kyc
export const documentTypeForm = 'document-type';
export const dataForm = 'data-form';
export const confirmationMessage = 'confirmation-message';
export const pending = 'PENDING';
export const approved = 'APPROVED';

// periods
export const month = 'MONTH';
export const week = 'WEEK';
export const periods = ['WEEK', 'MONTH', 'QUARTER', 'YEAR'];

// aum currency
export const AUM = 'AUM';

// Attachments
export const maxAttachmentSizeBytes = 2 * 1000000; // 2 MB
export const allowedProfileImageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'];
export const allowedAttachmentMimeTypes = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/zip',
  'application/vnd.rar',
  'application/octet-stream',
  'application/postscript',
  'text/plain',
  'text/csv',
  'text/html',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/gif',
  'image/tiff',
  'audio/mpeg',
  'video/quicktime'
];

// Statuses colors
export const statusesColors = {
  APPROVED: '#9CD54F',
  NEW_REQUEST: '#FCD861',
  IN_PROGRESS: '#FCD861',
  CANCELED: '#B5554D',
  REJECTED: '#B5554D'
};
